export function buildAclRoleForm(role = null) {
  return {
    name: String(role?.name || '').trim(),
    slug: String(role?.slug || '').trim(),
    description: String(role?.description || '').trim(),
    permissionKeys: Array.isArray(role?.permissions) ? [...role.permissions].sort() : [],
  };
}

export function buildPermissionGroups(permissions) {
  const groups = new Map();

  (Array.isArray(permissions) ? permissions : []).forEach((permission) => {
    const group = String(permission?.group || '').trim();
    if (!group) {
      return;
    }

    if (!groups.has(group)) {
      groups.set(group, []);
    }

    groups.get(group).push(permission);
  });

  return [...groups.entries()]
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([group, items]) => ({
      group,
      permissions: [...items].sort((left, right) => String(left?.key || '').localeCompare(String(right?.key || ''))),
    }));
}

export function getAssignedRoleIds(roles) {
  return (Array.isArray(roles) ? roles : [])
    .map((role) => Number(role?.id || 0))
    .filter((id) => Number.isInteger(id) && id > 0);
}

export function getRoleById(roles, roleId) {
  const normalizedRoleId = String(roleId || '').trim();
  if (!normalizedRoleId) {
    return null;
  }

  return (Array.isArray(roles) ? roles : []).find((role) => String(role?.id || '').trim() === normalizedRoleId) || null;
}

export function validateAclRoleForm(form) {
  const errors = {};

  if (!String(form?.name || '').trim()) {
    errors.name = 'This field is required.';
  }

  if (!String(form?.slug || '').trim()) {
    errors.slug = 'This field is required.';
  }

  return errors;
}
